<template>
  <div class="row latest-news-row bg-color" v-if="news !== null">

    <div class="container">
      <div class="heading text-left">
        <h2>Últimas notícias</h2>
        <div class="view-all-news">ver todas</div>
      </div>

      <div class="news-list">
        <div class="single-new" v-for="newarticle in news" v-bind:onclick="'window.open(&quot;'+newarticle.link+'&quot;,\'_blank\')'">
          <div class="single-new-image" v-bind:style="'background-image:url('+newarticle.image+')'"></div>
          <div class="single-new-title" v-html="newarticle.title"></div><div class="single-new-info"><span class="tags">CS:GO</span>
          <span class="date">{{ newarticle.date }}</span></div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "LatestNews",
  props:['news']
}
</script>

<style scoped>
/* Latest news */

.latest-news-row {
  padding-top: 30px;
}

.latest-news-row .heading > .view-all-news {
  color:#FFF;
  opacity:0.3;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  display: inline;
  line-height: 12px;
  vertical-align: middle;
  padding-left: 10px;
  margin-left: 15px;
  border-left: 2px solid #FFF;
}

.latest-news-row .heading > h2 {
  display: inline;
  line-height: 35px;
}

.latest-news-row .news-list {
  display: flex;
  flex-wrap: nowrap;

}

.latest-news-row .news-list > .single-new {
  flex:1;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  text-align: left;
  color:#FFF;
  cursor:pointer;
}

.latest-news-row .news-list > .single-new > .single-new-title {
  font-size: 16px;
  line-height: 20px;
}

.latest-news-row .news-list > .single-new:not(:first-child){
  margin-left: 10px;
}

.latest-news-row .news-list > .single-new > .single-new-image{
  height: 150px;
  width:100%;
  margin-bottom: 5px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.latest-news-row .news-list > .single-new > .single-new-info {
  margin-top: 10px;
  font-size: 12px;
}

.latest-news-row .news-list > .single-new > .single-new-info > .tags {
  font-weight: bold;
  text-transform: uppercase;
}

.latest-news-row .news-list > .single-new > .single-new-info > .date {
  margin-left: 10px;
  opacity: 0.5;
}
</style>